import { UserPermissionsNumber } from 'types';

export type PermissionKey =
  | 'hasAdministratorPermission'
  | 'hasRequestCompensationPermission'
  | 'hasManageCompensationsPermission';

export class UserPermissions {
  static Administrator: UserPermissionsNumber = 1;
  static RequestCompensation: UserPermissionsNumber = 1 << 1;
  static ManageCompensations: UserPermissionsNumber = 1 << 2;

  static readonly BasePermissions = new UserPermissions(UserPermissions.RequestCompensation);

  permissionsNumber: UserPermissionsNumber;
  savedPermissionsNumber: UserPermissionsNumber;

  constructor(permissionsNumber: UserPermissionsNumber) {
    this.permissionsNumber = permissionsNumber;
    this.savedPermissionsNumber = permissionsNumber;
  }

  hasPermission(permissionsNumber: UserPermissionsNumber) {
    return (this.permissionsNumber & permissionsNumber) !== 0;
  }

  addPermission(permissionsNumber: UserPermissionsNumber) {
    this.permissionsNumber |= permissionsNumber;
  }

  removePermission(permissionsNumber: UserPermissionsNumber) {
    this.permissionsNumber ^= permissionsNumber;
  }

  togglePermission(permissionsNumber: UserPermissionsNumber, addPermission: boolean) {
    if (addPermission) {
      return this.addPermission(permissionsNumber);
    }

    this.removePermission(permissionsNumber);
  }

  get hasAdministratorPermission() {
    return this.hasPermission(UserPermissions.Administrator);
  }

  set hasAdministratorPermission(hasPermission: boolean) {
    this.togglePermission(UserPermissions.Administrator, hasPermission);
  }

  get hasRequestCompensationPermission() {
    return this.hasPermission(UserPermissions.RequestCompensation);
  }

  set hasRequestCompensationPermission(hasPermission: boolean) {
    this.togglePermission(UserPermissions.RequestCompensation, hasPermission);
  }

  get hasManageCompensationsPermission() {
    return this.hasPermission(UserPermissions.ManageCompensations);
  }

  set hasManageCompensationsPermission(hasPermission: boolean) {
    this.togglePermission(UserPermissions.ManageCompensations, hasPermission);
  }
}
